import api from "./api";

const BASE = "/validacao-fiscal";

const validacaoFiscalService = {
  // ===== Competências =====
  listarCompetencias: () => api.get(`${BASE}/competencias`),
  abrirCompetencia: (payload) => api.post(`${BASE}/competencias`, payload),
  obterCompetencia: (id) => api.get(`${BASE}/competencias/${id}`),
  obterPainel: (id) => api.get(`${BASE}/competencias/${id}/painel`),
  congelarCompetencia: (id) => api.post(`${BASE}/competencias/${id}/congelamento`),
  reabrirCompetencia: (id, motivo) => api.post(`${BASE}/competencias/${id}/reabertura`, { motivo }),

  // ===== Importações =====
  listarImportacoes: (competenciaId) => api.get(`${BASE}/competencias/${competenciaId}/importacoes`),
  lancarAA: (competenciaId, payload) => api.post(`${BASE}/competencias/${competenciaId}/importacoes/aa`, payload),
  uploadErp: (competenciaId, file) => {
    const formData = new FormData();
    formData.append("file", file);
    return api.post(`${BASE}/competencias/${competenciaId}/importacoes/erp`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  uploadDfe: (competenciaId, file) => {
    const formData = new FormData();
    formData.append("file", file);
    return api.post(`${BASE}/competencias/${competenciaId}/importacoes/dfe`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  obterImportacao: (id) => api.get(`${BASE}/importacoes/${id}`),

  // ===== Conciliação =====
  iniciarConciliacao: (competenciaId) => api.post(`${BASE}/competencias/${competenciaId}/conciliacoes`),

  // ===== Divergências / ajustes =====
  listarDivergencias: (competenciaId, params) => api.get(`${BASE}/competencias/${competenciaId}/divergencias`, { params }),
  obterDivergencia: (id) => api.get(`${BASE}/divergencias/${id}`),
  atualizarDivergencia: (id, payload) => api.patch(`${BASE}/divergencias/${id}`, payload),
  decidirDivergencia: (id, payload) => api.post(`${BASE}/divergencias/${id}/decisoes`, payload),
  anexarEvidencia: (id, file) => {
    const formData = new FormData();
    formData.append("file", file);
    return api.post(`${BASE}/divergencias/${id}/evidencias`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  aprovarAjuste: (ajusteId, aprovado = true) => api.post(`${BASE}/ajustes/${ajusteId}/aprovacao`, { aprovado }),
  ajudaRegra: (codigo) => api.get(`${BASE}/regras/${codigo}`),

  // ===== Crédito travado / RAD / saldo credor =====
  obterCreditoTravado: (competenciaId) => api.get(`${BASE}/competencias/${competenciaId}/credito-travado`),
  registrarDecisaoRad: (competenciaId, payload) => api.post(`${BASE}/competencias/${competenciaId}/decisoes-rad`, payload),
  registrarSaldoCredor: (competenciaId, payload) => api.post(`${BASE}/competencias/${competenciaId}/saldo-credor`, payload),

  // ===== Liquidação planejada =====
  obterLiquidacao: (competenciaId) => api.get(`${BASE}/competencias/${competenciaId}/liquidacao`),
  projetarLiquidacao: (competenciaId) => api.post(`${BASE}/competencias/${competenciaId}/liquidacao/projecoes`),
  registrarDecisaoLiquidacao: (competenciaId, payload) =>
    api.post(`${BASE}/competencias/${competenciaId}/liquidacao/decisoes`, payload),

  // ===== Dossiê =====
  obterDossie: (competenciaId) => api.get(`${BASE}/competencias/${competenciaId}/dossies`),
  gerarDossie: (competenciaId, parecer) => api.post(`${BASE}/competencias/${competenciaId}/dossies`, { parecer }),
  aprovarDossie: (dossieId) => api.post(`${BASE}/dossies/${dossieId}/aprovacao`),
  baixarDossieUrl: (dossieId) => `${api.defaults.baseURL}${BASE}/dossies/${dossieId}/arquivo`,
};

export default validacaoFiscalService;
